/* eslint-disable import/no-anonymous-default-export */
import React, { useContext, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import UsuariosContext, { UsuariosProvider } from '../../common/contexts/UsuariosContext';

export default (props: { children: React.ReactNode }) => {
    const context = useContext(UsuariosContext);
    const location = useLocation();
    const [loggedIn, setLoggedIn] = useState<boolean>();

    useEffect(() => {
        setLoggedIn(context.checkAuth());
    }, []);

    return (
        <>
            {loggedIn === false && <Navigate to={"/login"} state={{ from: location }} replace />}
            {loggedIn === true &&
                location.pathname.indexOf("/lotes-renombrado/renombrar") == -1 &&
                context.user?.rol.nombre == "Renombrador" &&
                <Navigate to={"/lotes-renombrado/renombrar"} state={{ from: location }} replace />}

            {loggedIn === true && props.children}
        </>
    );
};